import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventEmitterService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
        this.invokeIndicatorsRefresh = new EventEmitter();
        this.invokeCalendarRefresh = new EventEmitter();
    }
    onFirstComponentButtonClick() {
        this.invokeFirstComponentFunction.emit();
    }
    onIndicatorsRefresh() {
        this.invokeIndicatorsRefresh.emit();
    }
    onCalendarRefresh() {
        this.invokeCalendarRefresh.emit();
    }
}
EventEmitterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventEmitterService_Factory() { return new EventEmitterService(); }, token: EventEmitterService, providedIn: "root" });
